<script>
import Username from '@wielink-application/shared/vue/components/form/horizontal/username.vue'

export default Username;
</script>